import React, { useState, useEffect } from "react";
import { useLocation, Link, useNavigate, useParams } from "react-router-dom";
import HeaderLeft from "./HeaderLeft";
import DropdownRight from "./DropdownRight";
import GetStorage from "../services/Storage";
import http from "../services/http";
import polygon from "../assets/images/Polygon 56.png";
import Modal from "react-bootstrap/Modal";
import ReactStars from "react-rating-stars-component";
import { SpinnerCircular } from "spinners-react";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";

function AnalystApplicantJohnDoe(props) {
  const token = GetStorage.get("xAuthToken");
  const analystName = GetStorage.get("selectedAnalystName");
  const [error, setError] = useState("");
  const [analyst, setAnalyst] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploadSpin, setUploadSpin] = useState(false);
  const params = useParams();
  const { id } = params;

  // const location = useLocation();
  // const { id } = location.state;
  const handleShow = () => setShow(true);
  const [showModal, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const [videoquality, setVideoquality] = useState("");
  const [speachquality, setSpeachquality] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    applicants();
  }, []);

  const applicants = (e) => {
    setLoading(true);

    http
      .get(`api/analyst/applicants/${id}/bucket?token=${token}`)
      .then((res) => {
        console.log("buckets===>", res.data);
        setAnalyst(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        console.log("error ", error.response.data.errors);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  const ratingChanged = (videoquality) => {
    setVideoquality(videoquality);
  };

  const ratingChangeds = (speachquality) => {
    setSpeachquality(speachquality);
  };

  const [inputText, setInputText] = useState("");

  const handleSubmit = async () => {
    setUploadSpin(true);

    http
      .post(`api/analyst/applicants/rate?token=${token}`, {
        analyst_id: id,
        speech: speachquality,
        video: videoquality,
        feedback: inputText,
      })
      .then((res) => {
        setUploadSpin(false);

        console.log(" ------->>>>", res.data);
        handleClose();

        navigate("/analystApplication");
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };


  const handleAnalystApproveOrReject = (status) => {
     let analystDetails = {
        id : id,
        value : 1
     }

     if(status === 'Approved'){
      analystDetails["action"] = "Approved"
     }else if(status === 'Rejected'){
      analystDetails["action"] = "Rejected"
     }

    setLoading(true)
    http
      .post(`api/analyst/update/applicants-status?token=${token}`, analystDetails)
      // .post(`api/analyst/applicants/status?token=${token}`, analystDetails)
      .then((res) => {
        setLoading(false);
        showToast("success", res.data.message);
        setTimeout(() => {
          navigate("/analystApplication");
        }, 3000);
      })
      .catch((error) => {
        setLoading(false)
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
     
  }

  return (
    <>
      <header>
        <div className="custom_container ">
          <HeaderLeft />
          <div className="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>

      <section className="otp_verification">
        <div className="login_inner">
          <h1 className=" main_title ">Analyst Applicant: {analystName} </h1>
          <div className="personal_and_bank_info mt-5">
            {/* <ul
              className="nav nav-pills  border-bottom-0 "
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item">
                {" "}
                <button
                  className="nav-link active "
                  data-toggle="modal"
                  data-target="#star_rating"
                  onClick={handleShow}
                >
                  Rate Analyst
                </button>{" "}
              </li>
            </ul> */}
             <div className="d-flex d-flex justify-content-center">
            <button className="them_btn mx-2" style={{ borderRadius: '7px' }} onClick={() => handleAnalystApproveOrReject('Approved')}>
              Approve
            </button>
            <button className="them_btn_ouline" style={{ borderRadius: '7px' }} onClick={() => handleAnalystApproveOrReject('Rejected')}>
              Reject
            </button>
          </div>
            {analyst.length ? (
              <div className="custom_container mt-4">
                <div className="row">
                  {loading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        marginTop: 40,
                        backgroundColor: "#ffffffc2",
                      }}
                    >
                      <SpinnerCircular size="7%" />
                    </div>
                  ) : (
                    <>
                      {analyst?.map((item, key) => (
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                          <div
                            className="vedio_datile"
                            style={{ position: "relative" }}
                          >
                            {item.path ? (
                              <Link to="/video" state={{ video: item.path }}>
                                <video src={item.path} className="img-fluid" style={{width:"100%",height:"200px"}}/>
                                <img
                                  src={polygon}
                                  alt=""
                                  className="play-btn"
                                />
                              </Link>
                            ) : (
                              <h6>No video in bucket</h6>
                            )}
                          </div>
                        </div>
                      ))}
                    </>
                  )}

                  <Modal
                    className="starrating"
                    show={showModal}
                    onHide={handleClose}
                  >
                    <Modal.Header
                    // className="admin-header"
                    >
                      <Modal.Title as="h5">Rate Analyst</Modal.Title>
                      <button
                        onClick={handleClose}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        {" "}
                        <span aria-hidden="true">&times;</span>{" "}
                      </button>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="raings_star">
                        <p>Vedio Quality</p>
                        <div className="rates" style={{ marginRight: 10 }}>
                          <ReactStars
                            count={5}
                            onChange={ratingChanged}
                            size={30}
                            activeColor="#ffd700"
                          />
                        </div>
                      </div>
                      <div className="raings_star">
                        <p>Speech Quality</p>
                        <div className="rates" style={{ marginRight: 10 }}>
                          <ReactStars
                            count={5}
                            onChange={ratingChangeds}
                            size={30}
                            activeColor="#ffd700"
                          />
                        </div>
                      </div>
                      <div class="form-group custom_text_area">
                        <textarea
                          class="form-control"
                          placeholder="Give us any feedback"
                          rows="5"
                          style={{ height: 150 }}
                          onChange={(e) => {
                            setInputText(e.target.value);
                          }}
                        ></textarea>
                      </div>
                    </Modal.Body>

                    <h6 style={{ color: "red" }}>{error}</h6>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="them_btn_ouline "
                        onClick={handleClose}
                        // style={{ width: "50%", borderRadius: 10 }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="them_btn "
                        // style={{ width: "50%", borderRadius: 10 }}
                        onClick={handleSubmit}
                      >
                        {uploadSpin ? (
                          <SpinnerCircular className="button-spin" />
                        ) : (
                          "  Submit"
                        )}
                      </button>
                    </div>
                  </Modal>
                </div>
              </div>
            ) : (
              <div className="mt-5">No video found in bucket</div>
            )}
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

export default AnalystApplicantJohnDoe;
